import script from "./purchase-order-list.vue?vue&type=script&setup=true&lang=js"
export * from "./purchase-order-list.vue?vue&type=script&setup=true&lang=js"

import "./purchase-order-list.vue?vue&type=style&index=0&id=33e570ac&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33e570ac"]])

export default __exports__